export default __webpack_public_path__ + "static/media/order-new-card-success.57b4a96c.svg";